import React from "react";
import classes from "./Logo.module.css";
import styles from "./../../../styles/styles.module.css";

const Logo: React.FC = () => {
    return (
        <div className={[classes.Logo, styles.noselect].join(" ")}>
            <div>P</div>
        </div>
    );
};

export default Logo;
